import { render, staticRenderFns } from "./Organization-edit.vue?vue&type=template&id=1b0fbe50&"
import script from "./Organization-edit.vue?vue&type=script&lang=js&"
export * from "./Organization-edit.vue?vue&type=script&lang=js&"
import style0 from "./Organization-edit.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports